"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _shortid = _interopRequireDefault(require("shortid"));

var _reactIntl = require("react-intl");

var _en = _interopRequireDefault(require("react-intl/locale-data/en"));

var _togaCheckbox = _interopRequireDefault(require("@thinkific/toga-checkbox"));

var _togaPagination = _interopRequireDefault(require("@thinkific/toga-pagination"));

var _SimpleRow = _interopRequireDefault(require("./SimpleRow"));

var _LoadingRows = _interopRequireDefault(require("./LoadingRows"));

var _SelectionIndicator = _interopRequireDefault(require("./SelectionIndicator"));

var _ColumnSelector = _interopRequireDefault(require("./ColumnSelector"));

var _TableHeader = _interopRequireDefault(require("./TableHeader"));

var _constants = require("./constants");

var _Datatable = _interopRequireDefault(require("./Datatable.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(0, _reactIntl.addLocaleData)(_toConsumableArray(_en["default"]));

var cx = _bind["default"].bind(_Datatable["default"]);

var Datatable = /*#__PURE__*/function (_Component) {
  _inherits(Datatable, _Component);

  var _super = _createSuper(Datatable);

  function Datatable(props) {
    var _this;

    _classCallCheck(this, Datatable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getAllHeadersFor", function (dataExample) {
      return Array.isArray(dataExample) ? dataExample : Object.keys(dataExample);
    });

    _defineProperty(_assertThisInitialized(_this), "getHeadersFor", function (dataExample) {
      var columnsToHide = _this.state.columnsToHide;
      return Array.isArray(dataExample) ? dataExample.filter(function (_, index) {
        return !columnsToHide.includes(index);
      }) : Object.keys(dataExample).filter(function (header) {
        return !columnsToHide.includes(header);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getDataType", function (dataExample) {
      return Array.isArray(dataExample) ? _constants.DATATYPE_ARRAY : _constants.DATATYPE_OBJECT;
    });

    _defineProperty(_assertThisInitialized(_this), "getRowId", function (rowData, dataType) {
      return dataType === _constants.DATATYPE_ARRAY ? rowData[0] : rowData.id;
    });

    _defineProperty(_assertThisInitialized(_this), "checkForIndeterminate", function (selectedIds, totalNumberOfElements, isAllDatasetSelected) {
      return !isAllDatasetSelected && selectedIds.length > 0 && selectedIds.length < totalNumberOfElements;
    });

    _defineProperty(_assertThisInitialized(_this), "checkAllItemsAreSelectedInPage", function (data, selectedIds, dataType) {
      return data.every(function (item) {
        return selectedIds.includes(_this.getRowId(item, dataType), dataType);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSelectAllInThisPage", function (tableData, isAllItemsSelected) {
      var selectionHandleSelectAll = _this.props.selectionHandleSelectAll;
      var rowsToChange = tableData.map(function (row) {
        return _this.getRowId(row, _this.getDataType(row));
      }); // if all items in the page are selected the handler should remove
      // from the selected ids to have the toggle behaviour

      var shouldRemove = isAllItemsSelected;
      selectionHandleSelectAll(rowsToChange, shouldRemove);
    });

    _defineProperty(_assertThisInitialized(_this), "handleNewCoulumnsToShow", function (newColumnsToShow) {
      var _this$props = _this.props,
          data = _this$props.data,
          propsColumnsToHide = _this$props.columnsToHide;

      var allHeaders = _this.getAllHeadersFor(data[0]);

      var newColumnsToHide = allHeaders.filter(function (header) {
        return !newColumnsToShow.includes(header);
      });
      /* new columns to hide is the union of
        blacklisted +
        the props (always hidden) +
        new list from the selector component
      */

      _this.setState({
        columnsToHide: [].concat(_toConsumableArray(_constants.BLACKLISTED_HEADERS), _toConsumableArray(propsColumnsToHide), _toConsumableArray(newColumnsToHide))
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createSelectCheckboxOnChangeHandler", function (dataWithoutHeaders, isAllItemsInThePageSelected) {
      return function () {
        return _this.toggleSelectAllInThisPage(dataWithoutHeaders, isAllItemsInThePageSelected);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "updateDimensions", function () {
      var tableElement = document.getElementById('datatable');
      if (!tableElement) return;

      _this.setState({
        tableWidth: tableElement.clientWidth
      });
    });

    var _this$props2 = _this.props,
        _columnsToHide = _this$props2.columnsToHide,
        columnSelectorConfig = _this$props2.columnSelectorConfig;
    var columnsToHideFromColumnSelector = [];

    if (columnSelectorConfig) {
      columnsToHideFromColumnSelector = columnSelectorConfig.reduce(function (columns, column) {
        return columns.concat(column.fields);
      }, []).filter(function (column) {
        return column.visible === false;
      }).map(function (column) {
        return column.headerName;
      });
    }

    _this.state = {
      columnsToHide: [].concat(_toConsumableArray(_constants.BLACKLISTED_HEADERS), _toConsumableArray(_columnsToHide), _toConsumableArray(columnsToHideFromColumnSelector)),
      tableWidth: 0
    };
    _this.tableElement = null;
    return _this;
  }
  /**
   * Add event listener to get the component width
   */


  _createClass(Datatable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions);
    }
    /**
     * Remove event listener to get the component width
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.tableElement.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          data = _this$props3.data,
          currentPage = _this$props3.currentPage,
          recordType = _this$props3.recordType,
          handleSort = _this$props3.handleSort,
          isAllDatasetSelected = _this$props3.isAllDatasetSelected,
          customRowElement = _this$props3.customRowElement,
          customColumnDisplayName = _this$props3.customColumnDisplayName,
          columnSelectorConfig = _this$props3.columnSelectorConfig,
          headerLeftAccessory = _this$props3.headerLeftAccessory,
          headerRightAccessory = _this$props3.headerRightAccessory,
          currentSort = _this$props3.currentSort,
          rowActions = _this$props3.rowActions,
          hasFrozenColumns = _this$props3.hasFrozenColumns,
          hasNoTitlebar = _this$props3.hasNoTitlebar,
          isFullScreen = _this$props3.isFullScreen,
          isLoading = _this$props3.isLoading,
          loadingRowsCount = _this$props3.loadingRowsCount,
          isNotSelectable = _this$props3.isNotSelectable,
          locale = _this$props3.locale,
          totalNumberOfElements = _this$props3.totalNumberOfElements,
          paginationEnd = _this$props3.paginationEnd,
          paginationStart = _this$props3.paginationStart,
          paginationDesiredNumberOfPages = _this$props3.paginationDesiredNumberOfPages,
          paginationGoTofirstHandler = _this$props3.paginationGoTofirstHandler,
          paginationGoTolastHandler = _this$props3.paginationGoTolastHandler,
          paginationGoToPageHandler = _this$props3.paginationGoToPageHandler,
          paginationNextHandler = _this$props3.paginationNextHandler,
          paginationPreviousHandler = _this$props3.paginationPreviousHandler,
          paginationTotalPages = _this$props3.paginationTotalPages,
          rightAlignedColumns = _this$props3.rightAlignedColumns,
          selectedIds = _this$props3.selectedIds,
          selectionHandleClearSelections = _this$props3.selectionHandleClearSelections,
          selectionHandleSelectAllInDataset = _this$props3.selectionHandleSelectAllInDataset,
          selectionHandleToggleRow = _this$props3.selectionHandleToggleRow,
          sortableColumns = _this$props3.sortableColumns;
      var _this$state = this.state,
          columnsToHide = _this$state.columnsToHide,
          tableWidth = _this$state.tableWidth; // Special case for empty tables

      if (data.length === 0) {
        data.push([]);
      }

      var headers = this.getHeadersFor(data[0]);
      var dataType = this.getDataType(data[0]);
      var dataWithoutHeaders = dataType === _constants.DATATYPE_ARRAY ? data.slice(1, data.length) : data;
      var pageSize = dataWithoutHeaders.length;
      var shouldFreezeActions = hasFrozenColumns;
      var isCompactMode = tableWidth < _constants.COMPACT_MODE_WIDTH;
      var isAllItemsInThePageSelected = this.checkAllItemsAreSelectedInPage(dataWithoutHeaders, selectedIds, dataType); // Gets the final number of headers, used in the loading state

      var numberOfHeaders = headers.length;

      if (!isNotSelectable) {
        numberOfHeaders += 1;
      }

      if (rowActions) {
        numberOfHeaders += 1;
      }

      if (shouldFreezeActions) {
        numberOfHeaders += 1;
      }

      return /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, {
        locale: locale
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('table-container', 'table-container--section', 'table-freeze-right', {
          'table-container--fullscreen': isFullScreen
        }),
        id: "datatable",
        ref: function ref(el) {
          _this2.tableElement = el;
          return _this2.tableElement;
        }
      }, !hasNoTitlebar && /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('table-container__header')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('table-container__header-toolbar')
      }, !isNotSelectable && /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('header-toolbar__checkbox--wrapper')
      }, /*#__PURE__*/_react["default"].createElement(_togaCheckbox["default"], {
        isChecked: isAllDatasetSelected || isAllItemsInThePageSelected,
        isIndeterminate: this.checkForIndeterminate(selectedIds, totalNumberOfElements, isAllDatasetSelected),
        onChange: this.createSelectCheckboxOnChangeHandler(dataWithoutHeaders, isAllItemsInThePageSelected)
      })), headerLeftAccessory), /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('table-container__header-settings')
      }, columnSelectorConfig && /*#__PURE__*/_react["default"].createElement(_ColumnSelector["default"], {
        config: columnSelectorConfig,
        handleApply: this.handleNewCoulumnsToShow,
        visibleColumns: headers
      }), headerRightAccessory && headerRightAccessory({
        visibleColumns: headers
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('table-container__header-pagination-info')
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: cx('table-container__header-info', {
          'table-container__header-info--border': headerRightAccessory || columnSelectorConfig
        })
      }, /*#__PURE__*/_react["default"].createElement("em", null, Number(paginationStart).toLocaleString(), ' - ', Number(paginationEnd).toLocaleString(), totalNumberOfElements && " of ".concat(Number(totalNumberOfElements).toLocaleString()))), /*#__PURE__*/_react["default"].createElement(_togaPagination["default"], {
        currentPage: currentPage,
        desiredNumberOfPages: paginationDesiredNumberOfPages,
        goTofirstHandler: paginationGoTofirstHandler,
        goTolastHandler: paginationGoTolastHandler,
        goToPageHandler: paginationGoToPageHandler,
        nextHandler: paginationNextHandler,
        previousHandler: paginationPreviousHandler,
        totalPages: paginationTotalPages,
        isCompactMode: true
      }))), (isAllDatasetSelected || selectedIds.length > 0) && /*#__PURE__*/_react["default"].createElement(_SelectionIndicator["default"], {
        clearSelectionCallback: selectionHandleClearSelections,
        isAllDatasetSelected: isAllDatasetSelected,
        pageSize: pageSize,
        recordType: recordType,
        selectAllDatasetCallback: selectionHandleSelectAllInDataset,
        selectedIds: selectedIds,
        totalRecords: totalNumberOfElements
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('table-container__content')
      }, /*#__PURE__*/_react["default"].createElement("table", {
        className: cx('table')
      }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement(_TableHeader["default"], {
        currentSort: currentSort,
        customColumnDisplayName: customColumnDisplayName,
        handleSort: handleSort,
        hasRowActions: rowActions && rowActions.length > 0,
        headers: headers,
        isCompactMode: isCompactMode,
        isLoading: isLoading,
        isNotSelectable: isNotSelectable,
        rightAlignedColumns: rightAlignedColumns,
        shouldFreezeActions: shouldFreezeActions,
        sortableColumns: sortableColumns
      })), /*#__PURE__*/_react["default"].createElement("tbody", null, isLoading && /*#__PURE__*/_react["default"].createElement(_LoadingRows["default"], {
        numberOfColumns: numberOfHeaders,
        numberOfRows: loadingRowsCount
      }), !isLoading && dataWithoutHeaders.map(function (rowData) {
        return customRowElement ? customRowElement({
          columnsToHide: columnsToHide,
          handleToggle: selectionHandleToggleRow,
          rowItemId: _this2.getRowId(rowData, dataType),
          key: _shortid["default"].generate(),
          hasFreezeActions: shouldFreezeActions,
          clearSelections: selectionHandleClearSelections,
          tableWidth: tableWidth,
          rowData: rowData,
          selectedIds: selectedIds,
          rowActions: rowActions,
          isNotSelectable: isNotSelectable,
          isAllDatasetSelected: isAllDatasetSelected
        }) : /*#__PURE__*/_react["default"].createElement(_SimpleRow["default"], {
          columnsToHide: columnsToHide,
          handleToggle: selectionHandleToggleRow,
          hasFreezeActions: shouldFreezeActions,
          isAllDatasetSelected: isAllDatasetSelected,
          isNotSelectable: isNotSelectable,
          key: _shortid["default"].generate(),
          rowActions: rowActions,
          rowData: rowData,
          rowItemId: _this2.getRowId(rowData, dataType),
          selectedIds: selectedIds,
          tableWidth: tableWidth
        });
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('table-container__footer')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('table-container__footer-info')
      }, /*#__PURE__*/_react["default"].createElement("em", null, dataWithoutHeaders.length, " ", recordType)), /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('table-container__footer-pagination')
      }, /*#__PURE__*/_react["default"].createElement(_togaPagination["default"], {
        currentPage: currentPage,
        desiredNumberOfPages: paginationDesiredNumberOfPages,
        goTofirstHandler: paginationGoTofirstHandler,
        goTolastHandler: paginationGoTolastHandler,
        goToPageHandler: paginationGoToPageHandler,
        nextHandler: paginationNextHandler,
        previousHandler: paginationPreviousHandler,
        totalPages: paginationTotalPages
      })))));
    }
  }]);

  return Datatable;
}(_react.Component);

Datatable.propTypes = {
  /** The configuration object for the column selector
   * when provided the column selector will show.
   */
  columnSelectorConfig: _propTypes["default"].array,

  /** Array of columns to hide from the datatable,
   * it can strings if the data is an object or
   * indexes if the data is an array */
  columnsToHide: _propTypes["default"].array,

  /** The current page to show in the navigation */
  currentPage: _propTypes["default"].number,

  /** The current sort applied to the table, the sorting itself is done
   * via the parent component or a backend this is for the handleSort
   * propagate the right values */
  currentSort: _propTypes["default"].shape({
    direction: _propTypes["default"].oneOf([_constants.SORT_DIRECTION_ASC, _constants.SORT_DIRECTION_DESC, null]),
    field: _propTypes["default"].string
  }),

  /** By default the table will display the key as the column header
   * you can use this prop as a hashtable to show human friendly names
   * example: { 'key': 'Human name', 'signInCount': 'Sign in count' }
   * * */
  customColumnDisplayName: _propTypes["default"].object,

  /** You can use this to pass a custom row to be rendered then you
   * have full freedon, it's a render prop and the available params passed down
   * are: columnsToHide, handleToggle, key, hasFreezeActions, rowData, selectedIds,
   * rowActions, tableWrapperWidth. You can find examples in the stories
   */
  customRowElement: _propTypes["default"].func,

  /** The data source to create the table, it can be an array or an object
   * Check the stories source to see examples
   */
  data: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]).isRequired,

  /** Callback that is called then the use clicks on a table header */
  handleSort: _propTypes["default"].func,

  /** Tells the table to apply the frozen column UX or not */
  hasFrozenColumns: _propTypes["default"].bool,

  /** Hides the title bar */
  hasNoTitlebar: _propTypes["default"].bool,

  /** Left accessory box is a render prop that receives the selected_ids
   *
   */
  headerLeftAccessory: _propTypes["default"].element,

  /** This is a render prop and will be rendered on the right side of
   * the header but left from the pagination. Arguments passed down are 'visibleColumns'
   */
  headerRightAccessory: _propTypes["default"].func,

  /** Special prop to behave like the whole dataset is selected
   * Like when the table shows 10 rows but on the backend you want
   * to do the operation in all 9999 rows you have in the db
   */
  isAllDatasetSelected: _propTypes["default"].bool,

  /** Tells datatable if should render the fullscreen version */
  isFullScreen: _propTypes["default"].bool,

  /** Activates the loading state */
  isLoading: _propTypes["default"].bool,

  /** Hides the selection checkboxes */
  isNotSelectable: _propTypes["default"].bool,

  /** Number of rows to show on loading */
  loadingRowsCount: _propTypes["default"].number,

  /** The datatable support locale data through react-intl */
  locale: _propTypes["default"].string,

  /** The number of items to be shown on the pagination elements */
  paginationDesiredNumberOfPages: _propTypes["default"].number,

  /** Add the end paginaation number */
  paginationEnd: _propTypes["default"].number,
  paginationGoTofirstHandler: _propTypes["default"].func,
  paginationGoTolastHandler: _propTypes["default"].func,
  paginationGoToPageHandler: _propTypes["default"].func,
  paginationNextHandler: _propTypes["default"].func,
  paginationPreviousHandler: _propTypes["default"].func,

  /** Add the start pagination number */
  paginationStart: _propTypes["default"].number,

  /** Total number of pages in the dataset, used in the pagination calculations  */
  paginationTotalPages: _propTypes["default"].number,

  /** A string that is shown on the selection ex. 1-10 "Users" users is the record type */
  recordType: _propTypes["default"].string,

  /** Columns that will render the column heading aligned to the right */
  rightAlignedColumns: _propTypes["default"].array,

  /** Actions to be provided to an inlineActions component, those will show as the last column */
  rowActions: _propTypes["default"].array,

  /** The ids that are selected in the dataset  */
  selectedIds: _propTypes["default"].array,

  /** Callback for when the user hits the clear selection link */
  selectionHandleClearSelections: _propTypes["default"].func,

  /** Callback for when the user hits the select all link */
  selectionHandleSelectAll: _propTypes["default"].func,

  /** Callback for when the user clicks on the select all link */
  selectionHandleSelectAllInDataset: _propTypes["default"].func,

  /** Callback for when the user hits a checkbox on a row, will call this
   * with the id as a parameter
   */
  selectionHandleToggleRow: _propTypes["default"].func,

  /** Tells the datatable which columns are sortable,
   * hides the arrows for columns that are not here */
  sortableColumns: _propTypes["default"].array,

  /** Total number of elements in the dataset, used to show pagination info */
  totalNumberOfElements: _propTypes["default"].number
};
Datatable.defaultProps = {
  columnsToHide: [],
  currentSort: null,
  currentPage: 1,
  customColumnDisplayName: {},
  customRowElement: null,
  columnSelectorConfig: null,
  handleSort:
  /* istanbul ignore next */
  function handleSort() {},
  hasFrozenColumns: false,
  hasNoTitlebar: false,
  headerLeftAccessory: null,
  headerRightAccessory: null,
  isAllDatasetSelected: false,
  isFullScreen: false,
  isNotSelectable: false,
  isLoading: false,
  loadingRowsCount: 10,
  locale: 'en',
  rowActions: null,
  recordType: '',
  rightAlignedColumns: [],
  totalNumberOfElements: null,
  paginationStart: 0,
  paginationEnd: 0,
  paginationGoTofirstHandler:
  /* istanbul ignore next */
  function paginationGoTofirstHandler() {},
  paginationGoTolastHandler:
  /* istanbul ignore next */
  function paginationGoTolastHandler() {},
  paginationPreviousHandler:
  /* istanbul ignore next */
  function paginationPreviousHandler() {},
  paginationNextHandler:
  /* istanbul ignore next */
  function paginationNextHandler() {},
  paginationGoToPageHandler:
  /* istanbul ignore next */
  function paginationGoToPageHandler() {},
  paginationDesiredNumberOfPages: 1,
  paginationTotalPages: 1,
  selectionHandleToggleRow:
  /* istanbul ignore next */
  function selectionHandleToggleRow() {},
  selectionHandleSelectAll:
  /* istanbul ignore next */
  function selectionHandleSelectAll() {},
  selectionHandleSelectAllInDataset:
  /* istanbul ignore next */
  function selectionHandleSelectAllInDataset() {},
  selectionHandleClearSelections:
  /* istanbul ignore next */
  function selectionHandleClearSelections() {},
  sortableColumns: [],
  selectedIds: []
}; // force bump 1

var _default = Datatable;
exports["default"] = _default;